export default "__VITE_ASSET__CzPBeeYd__"